import React from 'react';
import { cn } from '@ideoz/ui';

/**
 * Connected (green, live "active" dot) / Available (muted) pill used on cards +
 * the detail header.
 */
export const StatusBadge: React.FC<{ connected: boolean; className?: string }> = ({
  connected,
  className,
}) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium',
      connected
        ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
        : 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400',
      className
    )}
  >
    {connected && (
      <span className="relative flex h-1.5 w-1.5" aria-hidden>
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
      </span>
    )}
    {connected ? 'Connected' : 'Available'}
  </span>
);

export default StatusBadge;
